import { boxShadow } from "../borders";
import { background, blue, white } from "../colors";
import { fontSize } from "../typography";

export const MuiButton = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      boxShadow: boxShadow.none,
      fontSize: fontSize.base,
      padding: "10px",
      textTransform: "none",
    },
    textPrimary: {
      color: blue[100],
    },
    colorPrimary: {
      color: blue[100],
    },
    outlinedPrimary: {
      borderColor: blue[100],
      color: blue[100],
    },
    containedPrimary: {
      backgroundColor: blue[100],

      "&.Mui-disabled": {
        backgroundColor: blue[25],
        color: white[100],
      },
    },
  },
};
